import styled from 'styled-components'

import media from 'utils/media'

export const StyledWrapper = styled.div`
   margin-bottom: 24px;
`

export const StyledCategories = styled.ul`
   display: flex;
   align-items: center;
   gap: 12px;
   margin-bottom: 24px;
   margin-left: auto;
   margin-right: auto;
   width: fit-content;

   ${media.greaterThan('md')`
      margin-left: unset;
      margin-right: unset;
   `};

   li {
      background-color: #172a411f;
      width: fit-content;
      border-radius: 4px;
      padding: 8px 12px;
      text-transform: capitalize;
      margin-bottom: 0;
   }

   a {
      font-weight: 300;
      font-size: 12px;
      line-height: 24px;
      letter-spacing: 2%;
      color: ${({ theme }) => (theme.darkMode ? theme.colors.white : theme.colors.accent)};
   }
`

export const StyledTitle = styled.h1`
   margin-bottom: 30px;
   color: ${({ theme }) => theme.colors.header};
   font-size: 36px;
   line-height: 36px;
   font-weight: 500;
   text-align: center;
   letter-spacing: -0.5px;
   margin-bottom: 36hpx;
   text-wrap: ${({ $disableTextBalance }) => ($disableTextBalance ? 'unset' : 'balance')};
   ${({ $disableTextBalance }) => $disableTextBalance && 'max-width: 530px;'}

   ${media.greaterThan('md')`
      text-align: left;
      font-size: 48px;
      line-height: 48px;
      margin-bottom: 24px;
   `};
`

export const StyledAuthors = styled.div`
   display: flex;
   align-items: center;
   margin: 12px auto;
   justify-content: center;
   ${media.greaterThan('md')`
      margin: 0;
   `};

   & > div:first-of-type {
      align-items: center;
      margin-right: 8px;
      display: flex;
   }
`

export const StyledAuthorImg = styled.div`
   width: 28px;
   height: 28px;
   border-radius: 50%;
   overflow: hidden;
   background-color: ${({ theme }) => theme.colors.textColor};
   transform: ${({ n }) => `translateX(${n * -12.5}px)`};  // 38px * 0.33 = 12.5px overlap
   position: relative;
   z-index: ${({ n }) => 5 + n};

   &:last-child {
      margin-right: ${({ n }) => `${n * -12.5}px`};  // Match the overlap
   }

   img {
      max-width: 100%;
      margin-bottom: 0;
   }
`

export const StyledAuthorName = styled.div`
   font-weight: 400;
   font-size: 18px;
   line-height: 28px;
   margin-left: 4px;
   color: ${({ theme }) => theme.colors.header};
   font-family: ${({ theme }) => theme.fonts.portrait};

   a {
      text-decoration: underline;

      &:hover {
         color: ${({ theme }) => theme.colors.hotCinnamon};
      }
   }
`

export const StyledDate = styled.div`
   font-weight: 300;
   font-size: 12px;
   line-height: 19px;
   letter-spacing: 2%;
   text-align: center;

   ${media.greaterThan('md')`
      text-align: left;
   `};
`
export const StyledInfo = styled.div`
   ${media.greaterThan('md')`
      display: flex;
      align-items: center;
      justify-content: space-between;
   `};
`
